(function () {
  var toggle = document.getElementById('nav-toggle');
  var nav = document.getElementById('mobile-nav');
  var header = document.getElementById('header');
  if (!toggle || !nav || !header) return;

  toggle.addEventListener('click', function () {
    var open = !nav.classList.contains('is-open');
    nav.classList.toggle('is-open', open);
    toggle.classList.toggle('is-active', open);
    toggle.setAttribute('aria-expanded', open);
    document.body.style.overflow = open ? 'hidden' : '';
    header.style.zIndex = open ? '1000' : '';
  });

  nav.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      nav.classList.remove('is-open');
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      header.style.zIndex = '';
    });
  });
})();

(function () {
  var form = document.querySelector('.consultation-form-js');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var submitBtn = form.querySelector('button[type="submit"]');
    var originalText = submitBtn.innerText;
    submitBtn.innerText = 'Redirecting...';
    submitBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        console.error('Error:', err);
        submitBtn.innerText = 'Error. Please try again.';
        submitBtn.disabled = false;
      });
  }, true);
})();

(function () {
  var productJsonEl = document.getElementById('product-json');
  if (!productJsonEl) return;

  var product;
  try {
    product = JSON.parse(productJsonEl.textContent);
  } catch (e) {
    return;
  }

  var radios = document.querySelectorAll('[name^="option-"]');
  var mainImg = document.getElementById('main-product-image');
  var variantInput = document.querySelector('input[name="id"]');
  var priceEl = document.querySelector('.pdp-price');
  var submitBtn = document.querySelector('.pdp-actions button[type="submit"]');
  var thumbs = document.querySelectorAll('.pdp-thumb');

  function getSelectedOptions() {
    var opts = [];
    product.options.forEach(function (name) {
      var handle = name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      var checked = document.querySelector('input[name="option-' + handle + '"]:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function findVariant(opts) {
    return product.variants.find(function (v) {
      return opts.every(function (val, i) { return v.options[i] === val; });
    });
  }

  function findVariantByImageId(imageId) {
    return product.variants.find(function (v) {
      return v.featured_image && v.featured_image.id === imageId;
    });
  }

  function selectVariant(variant) {
    if (!variant) return;
    variant.options.forEach(function (val, i) {
      var optName = product.options[i];
      var handle = optName.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      var radio = document.querySelector('input[name="option-' + handle + '"][value="' + val + '"]');
      if (radio) radio.checked = true;
    });
    updatePills();
    updateVariantState(variant);
  }

  function updateVariantState(variant) {
    if (!variant) return;
    variantInput.value = variant.id;
    if (priceEl) {
      priceEl.textContent = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add to Cart';
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sold Out';
      }
    }
    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    history.replaceState(null, '', url.toString());
  }

  function updateMainImage(variant) {
    if (variant.featured_image && mainImg) {
      mainImg.removeAttribute('srcset');
      mainImg.src = variant.featured_image.src.replace(/\?.*$/, '') + '?width=900';
      mainImg.alt = variant.featured_image.alt || product.title;
    }
  }

  function updateActiveThumbnail(variant) {
    if (!variant || !variant.featured_image) return;
    thumbs.forEach(function (t) {
      t.classList.remove('active');
      var img = t.querySelector('img');
      if (img && variant.featured_image.src.indexOf(img.src.replace(/\?.*$/, '').split('/').pop().split('?')[0]) > -1) {
        t.classList.add('active');
      }
    });
  }

  function updateAll() {
    var opts = getSelectedOptions();
    var variant = findVariant(opts);
    if (!variant) return;
    updateVariantState(variant);
    updateMainImage(variant);
    updateActiveThumbnail(variant);
  }

  function updatePills() {
    radios.forEach(function (r) {
      if (r.checked) {
        r.parentElement.style.borderColor = '#FF2D8B';
        r.parentElement.style.color = '#FF2D8B';
      } else {
        r.parentElement.style.borderColor = '';
        r.parentElement.style.color = '';
      }
    });
  }

  radios.forEach(function (r) {
    r.addEventListener('change', function () {
      updatePills();
      updateAll();
    });
  });

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var src = t.getAttribute('data-image-src');
      var imageId = parseInt(t.getAttribute('data-image-id'));
      if (mainImg && src) {
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
      }
      thumbs.forEach(function (th) { th.classList.remove('active'); });
      t.classList.add('active');
      var variant = findVariantByImageId(imageId);
      if (variant) selectVariant(variant);
    });
  });

  updatePills();
  updateAll();
})();
